export enum LoanCentricMobileDockIds {
  Home = "home",
  Loans = "loans",
  Settings = "settings",
}
